export const addInteractiveElement = () => {
  // This test element is a simple indicator to performance scripts that
  // we have completed the initial render and the page is responsive,
  // even though api requests may still be ongoing.
  const elem = document.createElement('div');
  elem.id = 'test-interactive';
  elem.style.display = 'none';
  document.body.appendChild(elem);
};
